/* eslint-disable react/no-unescaped-entities */
import React from "react";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { connect } from "react-redux";
import { Box } from "@mui/system";
import Icon_RX_card from "assets/images/Icon_RX_card.png";
import Icon_Pharmacy from "assets/images/Icon_Pharmacy.png";
import Icon_Bottle from "assets/images/Icon_Bottle.png";
import Icon_Notification from "assets/images/Icon_Notification.png";
import mobileone from "assets/images/mobileone.png";
import mobiletwo from "assets/images/mobiletwo.png";

const CenterContent = (props) => {
  const { organizationInfo, organizationLogo } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesMd = useMediaQuery(theme.breakpoints.down("md"));
  const matchesUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesSmallestWidth = useMediaQuery("(max-width:320px)");
  const matchesBtwn = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const matchesSmMdBtwn = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const orgcode = localStorage.getItem("orgCode");
  const isDTC = organizationInfo?.app?.appCode === "CVD";
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
    
  return (
    <Box>
      <Card
        sx={{
          backgroundColor: "#F0F2F0",
          overflow: "inherit",
          minHeight: "480px",
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          boxShadow: "none",
        }}
      >
        <CardContent
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          {matchesMd ? (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="h2LatoBlack"
                    sx={{
                      fontSize: matchesSmallestWidth ? "20px" : "20px",
                      lineHeight: "32px",
                      color: "#093d4c",
                    }}
                  >
                    {isHCPTemplate
                      ? "Saves HCP time, patients money."
                      : "Save time, save money."}
                  </Typography>
                  <br />
                  <Typography
                    variant="h2LatoBlack"
                    sx={{
                      fontSize: matchesSmallestWidth ? "20px" : "20px",
                      lineHeight: "32px",
                      color: "#093d4c",
                    }}
                  >
                    Download the free app.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                xs={12}
                my={"22px"}
              >
                <Grid
                  item
                  xs={6}
                  sm={4}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{
                      width: matchesSmallestWidth
                        ? "120px"
                        : matchesSmMdBtwn
                        ? "23vw"
                        : "157px",
                    }}
                    src={
                      organizationLogo?.mobileOneBase64
                        ? organizationLogo?.mobileOneBase64
                        : mobileone
                    }
                    alt="mobileone"
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={4}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{
                      width: matchesSmallestWidth
                        ? "120px"
                        : matchesSmMdBtwn
                        ? "23vw"
                        : "157px",
                    }}
                    src={
                      organizationLogo?.mobileTwoBase64
                        ? organizationLogo?.mobileTwoBase64
                        : mobiletwo
                    }
                    alt="mobiletwo"
                  />
                </Grid>
              </Grid>
              {organizationInfo?.app?.appCode.toLowerCase() !== "cvd" && (
                <Grid item sm={12} sx={{ textAlign: "center" }}>
                  <Typography variant="h4LatoBold" sx={{ color: "red" }}>
                    Download '
                    {organizationInfo?.app?.appSettings?.appBannerConfig?.title}
                    ' app
                    <br />
                  </Typography>
                  {!isDTC && (
                    <Typography variant="h4LatoBlack" sx={{ color: "red" }}>
                      {isHCPTemplate ? "Requires free code" : "Use Code"}: {orgcode}
                    </Typography>
                  )}
                </Grid>
              )}
              <Grid
                item
                xs={12}
                container
                direction="row"
                sx={{
                  marginTop: matchesSm
                    ? undefined
                    : matchesSmMdBtwn
                    ? "5px"
                    : "40px",
                }}
              >
                <Box
                  className="icon-text-details"
                  sx={{
                    marginBottom: matchesSmallestWidth ? "32px" : "15px",
                    marginTop: matchesSmallestWidth ? undefined : "15px",
                  }}
                >
                  <Box
                    sx={{ height: "50px", width: "50px", marginRight: "24px" }}
                  >
                    <img
                      style={{ height: "50px", width: "50px" }}
                      src={Icon_RX_card}
                      alt="Icon_RX_card"
                    />
                  </Box>
                  <Box>
                    {isHCPTemplate ? (
                      <>
                        <Typography variant="h4LatoBlack">
                          Works in real time{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          to determine if a medication is covered by patient's
                          insurance
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography variant="h4LatoBlack">
                          Works in real time{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          to determine if a medication is covered by your
                          insurance
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
                <Box
                  className="icon-text-details"
                  sx={{
                    marginBottom: matchesSmallestWidth ? "32px" : "15px",
                    marginTop: matchesSmallestWidth ? undefined : "15px",
                  }}
                >
                  <Box
                    sx={{ height: "50px", width: "50px", marginRight: "24px" }}
                  >
                    <img
                      style={{ height: "50px", width: "50px" }}
                      src={Icon_Pharmacy}
                      alt="Icon_Pharmacy"
                    />
                  </Box>
                  <Box>
                    {isHCPTemplate ? (
                      <>
                        <Typography variant="h4LatoBlack">
                          Compares multiple discount cards{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          to find lowest cost to save at most local pharmacies
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography variant="h4LatoBlack">
                          Finds free coupons{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          that work at your local pharmacies
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
                <Box
                  className="icon-text-details"
                  sx={{
                    marginBottom: matchesSmallestWidth ? "32px" : "15px",
                    marginTop: matchesSmallestWidth ? undefined : "15px",
                  }}
                >
                  <Box
                    sx={{ height: "50px", width: "50px", marginRight: "24px" }}
                  >
                    <img
                      style={{ height: "50px", width: "50px" }}
                      src={Icon_Bottle}
                      alt="Icon_Bottle"
                    />
                  </Box>
                  <Box>
                    {isHCPTemplate ? (
                      <>
                        <Typography variant="h4LatoBlack">
                          Auto checks hundreds of copay coupons{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          from brand manufacturers
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography variant="h4LatoBlack">
                          Provides alternatives{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          {" "}
                          if a brand name drug is not covered by your insurance
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
                <Box
                  className="icon-text-details"
                  sx={{
                    marginBottom: matchesSmallestWidth ? "32px" : "15px",
                    marginTop: matchesSmallestWidth ? undefined : "15px",
                  }}
                >
                  <Box
                    sx={{ height: "50px", width: "50px", marginRight: "24px" }}
                  >
                    <img
                      style={{ height: "50px", width: "50px" }}
                      src={Icon_Notification}
                      alt="Icon_Notification"
                    />
                  </Box>
                  <Box>
                    {isHCPTemplate ? (
                      <>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          Regardless of insurance status,{" "}
                        </Typography>
                        <Typography variant="h4LatoBlack">
                          dials down{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          Rx cost for all your patient's
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography variant="h4LatoBlack">
                          Sends refill and dose reminders{" "}
                        </Typography>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{ color: "#083d4c" }}
                        >
                          to keep you on track
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              sx={{
                padding: matchesBtwn ? "20px" : "30px 40px 40px 165px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Grid item xs={12} sm={5}>
                <Box sx={{ marginRight: "24px" }}>
                  <Box sx={{ marginBottom: "23px" }}>
                    <Typography
                      variant="h2LatoBlack"
                      sx={{
                        fontSize: "20px",
                        lineHeight: "32px",
                        color: "#093d4c",
                      }}
                    >
                      {isHCPTemplate
                        ? "Saves HCP time, patients money."
                        : "Save time, save money."}
                    </Typography>
                    <br />
                    <Typography
                      variant="h2LatoBlack"
                      sx={{
                        fontSize: "20px",
                        lineHeight: "32px",
                        color: "#093d4c",
                      }}
                    >
                      Download the free app.
                    </Typography>
                  </Box>
                  <Box className="icon-text-details">
                    <Box
                      sx={{
                        width: "65px",
                        height: "65px",
                        marginRight: "18px",
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={Icon_RX_card}
                        alt="Icon_RX_card"
                      />
                    </Box>
                    <Box
                      mt={"11px"}
                      mb={"10px"}
                      sx={{ height: "44px", width: "400px" }}
                    >
                      {isHCPTemplate ? (
                        <>
                          <Typography variant="h4LatoBlack">
                            Works in real time{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            to determine if a medication is covered by patient's
                            insurance
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h4LatoBlack">
                            Works in real time{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            to determine if a medication is covered by your
                            insurance
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box>
                  <Box className="icon-text-details">
                    <Box
                      sx={{
                        width: "65px",
                        height: "65px",
                        marginRight: "18px",
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={Icon_Pharmacy}
                        alt="Icon_Pharmacy"
                      />
                    </Box>
                    <Box
                      mt={"11px"}
                      mb={"10px"}
                      sx={{ height: "44px", width: "400px" }}
                    >
                      {isHCPTemplate ? (
                        <>
                          <Typography variant="h4LatoBlack">
                            Compares multiple discount cards{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            to find lowest cost to save at most local pharmacies
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h4LatoBlack">
                            Finds free coupons{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            that work at your local pharmacies
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box>
                  <Box className="icon-text-details">
                    <Box
                      sx={{
                        width: "65px",
                        height: "65px",
                        marginRight: "18px",
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={Icon_Bottle}
                        alt="Icon_Bottle"
                      />
                    </Box>
                    <Box
                      mt={"11px"}
                      mb={"10px"}
                      sx={{ height: "44px", width: "400px" }}
                    >
                      {isHCPTemplate ? (
                        <>
                          <Typography variant="h4LatoBlack">
                            Auto checks hundreds of copay coupons{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            from brand manufacturers
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h4LatoBlack">
                            Provides alternatives{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            if a brand name drug is not covered by your
                            insurance
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box>
                  <Box className="icon-text-details">
                    <Box
                      sx={{
                        width: "65px",
                        height: "65px",
                        marginRight: "18px",
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={Icon_Notification}
                        alt="Icon_Notification"
                      />
                    </Box>
                    <Box
                      mt={"11px"}
                      mb={"10px"}
                      sx={{ height: "44px", width: "400px" }}
                    >
                      {isHCPTemplate ? (
                        <>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            Regardless of insurance status,{" "}
                          </Typography>
                          <Typography variant="h4LatoBlack">
                            dials down{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            Rx cost for all your patient's
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h4LatoBlack">
                            Sends refill and dose reminders{" "}
                          </Typography>
                          <Typography
                            variant="h2LatoRegular"
                            sx={{ color: "#083d4c" }}
                          >
                            to keep you on track
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                container
                xs={12}
                sm={7}
                md={7}
                lg={5}
                sx={{ marginTop: matchesUpMd ? "-80px" : undefined }}
              >
                <Grid item sm={6} sx={{ textAlign: "right" }}>
                  <img
                    style={{
                      width: matches ? "100%" : undefined,
                    }}
                    src={
                      organizationLogo?.mobileOneBase64
                        ? organizationLogo?.mobileOneBase64
                        : mobileone
                    }
                    alt="mobileone"
                    className="mobile-img"
                  />
                </Grid>
                <Grid item sm={6}>
                  <img
                    style={{
                      width: matches ? "100%" : undefined,
                    }}
                    src={
                      organizationLogo?.mobileTwoBase64
                        ? organizationLogo?.mobileTwoBase64
                        : mobiletwo
                    }
                    alt="mobiletwo"
                    className="mobile-img mobile-img2"
                  />
                </Grid>

                {organizationInfo?.app?.appCode.toLowerCase() !== "cvd" && (
                  <Grid item sm={12} sx={{ textAlign: "center" }}>
                    <Typography variant="h4LatoBold" sx={{ color: "red" }}>
                      Download '
                      {organizationInfo?.app?.appSettings?.appBannerConfig?.title}
                      ' app
                      <br />
                    </Typography>
                    {!isDTC && (
                      <Typography variant="h4LatoBlack" sx={{ color: "red" }}>
                        {isHCPTemplate ? "Requires free code" : "Use Code"}: {orgcode}
                      </Typography>
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    organizationLogo: state.organizationLogo.data,
  };
};

export default connect(mapStateToProps)(CenterContent);
